// SSR related (used on both server & client side)

export async function resolveVueModule(vue_module_logical_path: string) {
  if (vue_module_logical_path.startsWith("apps/spacious_website/pages/") && vue_module_logical_path.endsWith(".vue")) {
    // entry keys (value in `component_key`) are relative path from `sourceCodeDir`
    // return APPS_SPACIOUS_WEBSITE_PAGES_MODULES[`/javascripts/${vue_module_logical_path}`]
    //
    // glob pattern (1st argument in `import.meta.glob` MUST stay as string instead of variable/constant)
    // Vite can only transform these into dynamic imports this way
    // From doc - https://vitejs.dev/guide/features#glob-import-caveats
    // > You should also be aware that all the arguments in the import.meta.glob must be passed as literals. You can NOT use variables or expressions in them.
    const component_key = `/javascripts/${vue_module_logical_path}`
    if (import.meta.env.SSR) {
      // For server side, eager import enabled
      return import.meta.glob("apps/spacious_website/pages/**/*.vue", {
        import: "default",
        eager:  true,
      })[component_key]
    }
    // For client side, lazy import enabled
    const modules = import.meta.glob("apps/spacious_website/pages/**/*.vue", {
      import: "default",
    })
    // The values are functions (to be executed to import modules, lazily)
    return modules[component_key]()
  }
  else {
    switch (vue_module_logical_path) {
      case "~/ssr/App.vue":
        // For testing only
        return (await import("~/ssr/App.vue")).default
      default:
        // Nothing we can do, not found
        return null
    }
  }
}
